"use strict";

/**
 * @module Services.Control
 */
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CloseClientRequest = void 0;
/**
 * Data type for a CLOSE_CLIENT request.
 */
var CloseClientRequest = /** @class */function () {
  /**
   * Create a new CloseClientRequest instance
   *
   * @param sessionID a session ID
   */
  function CloseClientRequest(sessionID) {
    this.sessionID = sessionID;
  }
  /**
   * Convert object to string
   *
   * @return a string representation of the CloseClientRequest
   */
  CloseClientRequest.prototype.toString = function () {
    return 'CloseClientRequest [' + this.sessionID + ']';
  };
  return CloseClientRequest;
}();
exports.CloseClientRequest = CloseClientRequest;